import type {ReactNode, MouseEvent} from 'react'
import {Link} from 'react-router-dom'
import {cn} from '@/lib/utils'

type TextLinkSize = 'xs' | 'sm' | 'base'

interface TextLinkProps {
    to: string
    state?: unknown
    children: ReactNode
    testId?: string
    stopPropagation?: boolean
    variant?: 'default' | 'bold'
    size?: TextLinkSize
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const sizeClasses: Record<TextLinkSize, string> = {
    xs: 'text-xs',
    sm: 'text-sm',
    base: 'text-base',
}
/* eslint-enable i18next/no-literal-string */

export function TextLink({to, state, children, testId, stopPropagation, variant = 'default', size}: TextLinkProps) {
    const handleClick = (e: MouseEvent) => {
        if (stopPropagation) {
            e.stopPropagation()
        }
    }

    return (
        <Link
            to={to}
            state={state}
            data-testid={testId}
            className={cn(
                'text-primary hover:underline focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none rounded-sm',
                variant === 'bold' && 'font-medium',
                size && sizeClasses[size],
            )}
            onClick={handleClick}
        >
            {children}
        </Link>
    )
}
